import { Instagram, Mail, Phone, ArrowUpRight } from "lucide-react";
import { profile } from "../data/mock";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1A1A1A] text-[#F5F1EA] pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10 pb-14 border-b border-[#F5F1EA]/15">
          <div className="col-span-12 md:col-span-6">
            <h3 className="font-display text-[56px] md:text-[96px] leading-[0.95] tracking-tight">
              Let's tell
              <br />
              <span className="italic-display text-[#C2B8A3]">your story.</span>
            </h3>
            <a
              href={`mailto:${profile.email}`}
              className="mt-8 inline-flex items-center gap-3 text-lg link-underline"
            >
              {profile.email} <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#C2B8A3] mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Mail size={14} />
                <a href={`mailto:${profile.email}`} className="link-underline">
                  {profile.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={14} />
                <a href={`tel:${profile.phone}`} className="link-underline">
                  {profile.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram size={14} />
                <a href={profile.instagramUrl} target="_blank" rel="noreferrer" className="link-underline">
                  {profile.instagram}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#C2B8A3] mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              {[
                { id: "about", l: "About" },
                { id: "photography", l: "Photography" },
                { id: "video", l: "Video" },
                { id: "services", l: "Services" },
                { id: "contact", l: "Book a Session" },
              ].map((x) => (
                <li key={x.id}>
                  <button
                    onClick={() =>
                      document.getElementById(x.id)?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="link-underline"
                  >
                    {x.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#F5F1EA]/60">
          <div>© {year} Kenny Rodriguez Photography. All rights reserved.</div>
          <div className="tracking-[0.2em] uppercase">Based in San Marcos, TX · Austin · San Antonio</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
